import appFetch from '../utils/appFetch';
import { getCountryCode } from '../utils/countryMapping';

export interface RateRequest {
  origin: string;
  destination: string;
  weight: number;
  length?: number;
  breadth?: number;
  height?: number;
  pcs?: number;
}

export interface RateResponse {
  success: boolean;
  rate?: string;
  currency?: string;
  description?: string;
  error?: string;
}

export const rateService = {
  async calculateRate(request: RateRequest): Promise<RateResponse> {
    try {
      // Validate required fields
      if (!request.origin || !request.destination || !request.weight || request.weight <= 0) {
        console.warn('Rate calculation skipped: Missing required fields', request);
        return {
          success: false,
          error: 'Missing required fields for rate calculation'
        };
      }

      // Convert country names to codes if needed
      const originCode = getCountryCode(request.origin);
      const destinationCode = getCountryCode(request.destination);

      console.log('Calculating rate with params:', {
        origin: originCode,
        destination: destinationCode,
        weight: request.weight,
        length: request.length || 1,
        breadth: request.breadth || 1,
        height: request.height || 1
      });

      const response = await appFetch('/api/rate/calculate', {
        method: 'POST',
        body: JSON.stringify({
          origin: originCode,
          destination: destinationCode,
          weight: request.weight,
          length: request.length || 1,
          breadth: request.breadth || 1,
          height: request.height || 1,
          pcs: request.pcs || 1
        })
      });

      if (!response) {
        return {
          success: false,
          error: 'No response from rate calculation API'
        };
      }

      return response as RateResponse;
    } catch (error) {
      console.error('Error calculating rate:', error);
      return {
        success: false,
        error: 'Failed to calculate rate. Please try again.'
      };
    }
  }
};

export default rateService;

